












import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';

import { BaseSelect, selectName } from '#components/baseSelect';

import { apiProvider } from '../api';
import { NAME } from '../constants';

export default BaseSelect.extend({
	name: selectName(NAME),
	data() {
		return {
			storeObject: NAME,
			valueFieldName: 'DODAVATEL_ID',
			apiProvider,
		};
	},
	methods: {
		openCreate() {
			openEdit(NAME, PageMode.CREATE, { filter: { fromSelectCreate: true } });
		},
	},
});
